/**
 * 验证工具函数集合
 */

import { Coordinate } from '../types';

/**
 * 验证坐标对象是否有效
 */
export const isValidCoordinate = (location: any): location is Coordinate => {
  return (
    location !== null &&
    location !== undefined &&
    typeof location === 'object' &&
    typeof location.lng === 'number' &&
    typeof location.lat === 'number' &&
    !isNaN(location.lng) &&
    !isNaN(location.lat)
  );
};

/**
 * 验证坐标值是否在有效范围内
 */
export const isCoordinateInRange = (location: any): boolean => {
  if (!isValidCoordinate(location)) {
    return false;
  }

  // 经度范围: -180 到 180
  // 纬度范围: -90 到 90
  return (
    location.lng >= -180 &&
    location.lng <= 180 &&
    location.lat >= -90 &&
    location.lat <= 90
  );
};

/**
 * 获取坐标的安全值（用于导出等场景）
 */
export const getCoordinateValue = <T = string>(
  location: any,
  key: 'lng' | 'lat',
  defaultValue: T = '' as T
): number | T => {
  if (isValidCoordinate(location)) {
    return location[key];
  }
  return defaultValue;
};
